/* require-postal.js */
(function () {
  const LOG = (...a) => console.log('[postal]', ...a);

  function findCheckoutButtons(root) {
    const scope = root || document;
    return Array.from(scope.querySelectorAll(
      'button[name="checkout"], button[data-checkout], ' +
      'a[href*="/checkout"], ' +
      'form[action*="/checkout"] button[type="submit"]'
    ));
  }

  function ensurePostalField(root) {
    const scope = root || document;
    if (scope.querySelector('#cart-postal, [name="attributes[Postal code]"]')) return;

    const btn = findCheckoutButtons(scope)[0];
    if (!btn) return;

    const wrap = document.createElement('div');
    wrap.className = 'cart-extra-field';
    wrap.style.margin = '12px 0';

    wrap.innerHTML =
      '<label for="cart-postal" style="display:block;margin-bottom:6px;">' +
      'מיקוד <span aria-hidden="true" style="color:#e00">*</span></label>' +
      '<input id="cart-postal" name="attributes[Postal code]" type="text" ' +
      'inputmode="numeric" pattern="[0-9]{5,7}" placeholder="לדוגמה: 1234567" ' +
      'style="width:100%;padding:.7rem;border:1px solid #ccc;border-radius:6px" />' +
      '<small class="cart-postal-error" style="display:none;color:#e00;">' +
      'אנא הזן מיקוד (5–7 ספרות).</small>';

    btn.parentNode.insertBefore(wrap, btn);
    LOG('postal field injected near checkout button');
  }

  function showError(msg) {
    const err = document.querySelector('.cart-postal-error');
    if (err) { err.textContent = msg || 'אנא הזן מיקוד (5–7 ספרות).'; err.style.display = 'block'; }
  }

  function validatePostal() {
    const input = document.querySelector('#cart-postal, [name="attributes[Postal code]"]');
    if (!input) { LOG('no postal input found → allow'); return true; }
    const val = (input.value || '').trim();
    if (!val) { showError(); input.focus(); LOG('empty postal → block'); return false; }
    if (!/^[0-9]{5,7}$/.test(val)) { showError('מיקוד חייב להיות 5–7 ספרות.'); input.focus(); LOG('bad pattern → block'); return false; }
    LOG('postal ok:', val);
    return true;
  }

  function attachBlockers(root) {
    const scope = root || document;

    scope.addEventListener('click', function (e) {
      let el = e.target;
      for (let i = 0; i < 3 && el; i++, el = el.parentElement) {
        const isCheckout =
          (el.tagName === 'BUTTON' && (el.name === 'checkout' || el.getAttribute('data-checkout') !== null)) ||
          (el.tagName === 'A' && /\/checkout/i.test(el.getAttribute('href') || ''));

        if (isCheckout) {
          LOG('checkout click detected on', el);
          if (!validatePostal()) { e.preventDefault(); e.stopPropagation(); return; }
        }
      }
    }, true);

    scope.addEventListener('submit', function (e) {
      try {
        const submitter = e.submitter;
        const toCheckout = submitter && (submitter.name === 'checkout' || submitter.getAttribute('data-checkout') !== null);
        if (toCheckout) {
          LOG('form submit to checkout detected');
          if (!validatePostal()) { e.preventDefault(); e.stopPropagation(); }
        }
      } catch (err) { /* ignore */ }
    }, true);
  }

  function init() {
    LOG('init');
    ensurePostalField(document);
    attachBlockers(document);

    const mo = new MutationObserver(() => {
      ensurePostalField(document);
    });
    mo.observe(document.documentElement, {childList:true, subtree:true});

    setInterval(() => {
      document.querySelectorAll('*').forEach(el => {
        if (el.shadowRoot) {
          ensurePostalField(el.shadowRoot);
          attachBlockers(el.shadowRoot);
        }
      });
    }, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();